// config/routePermissions.js
// Matrice des permissions par route et niveau d'abonnement
// Pour modifier les accès, il suffit de changer ce fichier

// Raccourcis pour les groupes de niveaux
const TOUS = ['gratuit', 'testeur', 'basique', 'premium', 'admin'];
const TOUS_ET_ANONYME = ['anonyme', 'gratuit', 'testeur', 'basique', 'premium', 'admin'];
const PAYANTS = ['testeur', 'basique', 'premium', 'admin'];
const ADMIN = ['admin'];

const routePermissions = [
  // === Pages publiques (pas besoin d'être connecté) ===
  { path: '/login', public: true },
  { path: '/register', public: true },
  { path: '/mot-de-passe-oublie', public: true },
  { path: '/nouveau-mot-de-passe', public: true },
  { path: '/confirmer-email', public: true },

  // === Pages accessibles aux anonymes ET connectés ===
  { path: '/', acces: TOUS_ET_ANONYME },
  { path: '/exercice-conjugaison-partielle', acces: TOUS_ET_ANONYME },
  { path: '/exercice-conjugaison-complete', acces: TOUS_ET_ANONYME },
  { path: '/exercice-quiz-vocabulaire', acces: TOUS_ET_ANONYME },
  { path: '/exercice-matching', acces: TOUS_ET_ANONYME },
  { path: '/analyse', acces: TOUS_ET_ANONYME },
  { path: '/presentation', acces: TOUS_ET_ANONYME },
  { path: '/tarifs', acces: TOUS_ET_ANONYME },
  { path: '/mentions-legales', acces: TOUS_ET_ANONYME },
  { path: '/contact', acces: TOUS_ET_ANONYME },
  { path: '/conditions-generales', acces: TOUS_ET_ANONYME },

  // === Pages accessibles à tous les connectés ===
  { path: '/changer-niveau', acces: TOUS },
  { path: '/profil', acces: TOUS },
  { path: '/statistiques', acces: TOUS },
  { path: '/abonnement', acces: TOUS },

  // === Pages en construction (tous connectés) ===
  { path: '/exercice-quiz-grammaire', acces: TOUS },
  { path: '/exercice-flash-cards', acces: TOUS },

  // === Playlists (payants + testeurs) ===
  { path: '/playlists', acces: PAYANTS },

  // === Gestion (admin uniquement) ===
  { path: '/gestion/dashboard', acces: ADMIN },
  { path: '/gestion/mots', acces: ADMIN },
  { path: '/gestion/traductions-incompletes', acces: ADMIN },
  { path: '/gestion/mots-incomplets', acces: ADMIN },
  { path: '/gestion/coherence-verbes', acces: ADMIN },
  { path: '/gestion/mots-signales', acces: ADMIN },
  { path: '/gestion/questions-signalees', acces: ADMIN },
  { path: '/gestion/themes-generiques', acces: ADMIN },
  { path: '/gestion/mots-pending', acces: ADMIN },
  { path: '/gestion/enrichissement-complet', acces: ADMIN },
  { path: '/enrichissement', acces: ADMIN },
  { path: '/gestion/export', acces: ADMIN },
  { path: '/gestion/import', acces: ADMIN },
];

/**
 * Vérifie si un niveau d'accès a la permission pour une route
 * @param {string} path - Chemin de la route
 * @param {string} niveauAcces - Niveau d'abonnement de l'utilisateur (ou 'anonyme')
 * @returns {boolean} true si autorisé
 */
const hasPermission = (path, niveauAcces) => {
  const rule = routePermissions.find((r) => r.path === path);

  // Route non trouvée dans la config → autorisé par défaut (connecté suffit)
  if (!rule) return niveauAcces !== 'anonyme';

  // Route publique
  if (rule.public) return true;

  // Vérifier si le niveau est dans la liste autorisée
  return rule.acces.includes(niveauAcces);
};

/**
 * Vérifie si une route est publique (pas besoin d'être connecté)
 * @param {string} path - Chemin de la route
 * @returns {boolean}
 */
const isPublicRoute = (path) => {
  const rule = routePermissions.find((r) => r.path === path);
  return rule?.public === true;
};

/**
 * Vérifie si une route est accessible aux anonymes
 * @param {string} path - Chemin de la route
 * @returns {boolean}
 */
const isAnonymousRoute = (path) => {
  const rule = routePermissions.find((r) => r.path === path);
  if (!rule) return false;
  if (rule.public) return true;
  return rule.acces?.includes('anonyme') || false;
};

/**
 * Retourne la liste des routes autorisées pour un niveau
 * @param {string} niveauAcces - Niveau d'abonnement
 * @returns {string[]} Liste des paths autorisés
 */
const getAuthorizedRoutes = (niveauAcces) => {
  return routePermissions.filter((r) => r.public || (r.acces && r.acces.includes(niveauAcces))).map((r) => r.path);
};

export { routePermissions, hasPermission, isPublicRoute, isAnonymousRoute, getAuthorizedRoutes, TOUS, TOUS_ET_ANONYME, PAYANTS, ADMIN };
